module.exports = __webpack_public_path__ + "img/gestao3.a49aedc1.png";